// -------------------------------------
// #FUNCOES
// -------------------------------------

$(document).ready(function () {
    function debounce(func, wait) {
        var timer = null;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(func, wait);
        }
    }

    // Verificar qual tamanho da barra de rolagem
    function getScrollbarWidth() {
        // Creating invisible container
        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);

        // Creating inner element and placing it in the container
        var inner = document.createElement('div');
        outer.appendChild(inner);

        // Calculating difference between container's full width and the child width
        var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);

        return scrollbarWidth;
    }

    // Stick header
    var header = $('#header');
    var headerTopDistance = $(window).scrollTop();
    var headerHeight = header.outerHeight();
    var headerInnerHeight = header.height();
    var bodyOffset = $('#body-offset');
    bodyOffset.css({'padding-top': headerHeight - 1 + 'px'});

    if (headerTopDistance > 100) {
        header.addClass("header-stick");
    }

    // Scroll listener
    window.addEventListener('scroll', debounce(function(){
        headerTopDistance = $(window).scrollTop();

        if (headerTopDistance > 100) {
            header.addClass("header-stick");
        } else {
            header.removeClass("header-stick");
        }
    }, 10));

    // Other vars
    var scrollbar = getScrollbarWidth();
    var adminBar = $('#wpadminbar');

    // Menu mobile vars
    var btnMenuMobile = $('.btn-menu-mobile');
    var menuMobile = $('.menu-mobile');
    var menuOverlay = $('.menu-mobile-overlay');

    // Search vars
    var toggleSearch = $('[data-search="toggle"]');
    var searchOverlay = $('.search-overlay');
    var screenSearch = $('#mobile-search');

    // Open menu mobile
    function openMenuMobile() {
        var headerMobileHeight = header.outerHeight();

        if (adminBar.length) {
            headerMobileHeight += adminBar.outerHeight();
        }

        btnMenuMobile.addClass('is-active');
        menuMobile.addClass('is-active');
        menuOverlay.fadeIn();
        menuMobile.css({'padding-top': headerMobileHeight - 1 + 'px'});
        $('html').css({'margin-right': scrollbar+'px', 'overflow': 'hidden'});
        if (screenSearch.is(':visible')) {
            closeSearchMobile();
        }
    }

    // Close menu mobile
    function closeMenuMobile() {
        btnMenuMobile.removeClass('is-active');
        menuMobile.removeClass('is-active');
        menuOverlay.fadeOut();
        setTimeout(function(){
            $('html').css({'margin-right': '', 'overflow': ''});
        }, 300);
    }

    // Open search
    function openSearchMobile() {
        screenSearch.addClass('is-active');
        searchOverlay.fadeIn();
        screenSearch.find('.search-input').focus();
        if (menuMobile.is(':visible')) {
            closeMenuMobile();
        }
    }

    // Close search
    function closeSearchMobile() {
        screenSearch.removeClass('is-active');
        searchOverlay.fadeOut();
    }

    // Trigger menu mobile
    $('[data-menu-mobile="toggle"]').click(function(event) {
        if (menuMobile.hasClass('is-active')) {
            closeMenuMobile();
        } else {
            openMenuMobile();
        }
    });

    // Open submenu mobile
    $('.mobile-nav .menu-item-has-children').click(function(event) {
        $('.mobile-nav .sub-menu .menu-item').click(function(event) {
            event.stopPropagation();
        });
        if ($(this).children('.sub-menu').is(':visible')) {
            $(this).removeClass('is-active');
            $(this).children('.sub-menu').slideUp();
        } else {
            $(this).addClass('is-active');
            $(this).children('.sub-menu').slideDown();
        }
    });

    // Trigger search mobile
    $(toggleSearch).click(function() {
        if (screenSearch.hasClass('is-active')) {
            closeSearchMobile();
        } else {
            openSearchMobile();
        }
    });

    // Trigger whatsapp (open/close)
    var whatsappPopup = $('#whatsapp-popup');

    $('[data-whatsapp-popup="toggle"]').click(function(event) {
        whatsappPopup.toggleClass('is-active');
        whatsappPopup.fadeToggle('fast');
        if (whatsappPopup.hasClass('is-active')) {
            $(whatsappPopup).find('input:first').focus();
            $('html').css({'overflow': 'hidden'});
        } else {
            setTimeout(function(){
                $('html').css({'overflow': ''});
            }, 300);
        }
    });

    // Menu horizontal de categoria
    var catBlock = $('#cat-blog');
    var catList = $('#cat-list');

    if ($("body").has("#cat-blog").length) {
        var catPrev = $('#cat-prev');
        var catNext = $('#cat-next');

        if ($(catList).get(0).scrollWidth - $(catList).outerWidth() <= 0) {
            $(catBlock).addClass('no-scroll');
        }

        $(catPrev).click(function () {
            $(catList).animate({
                scrollLeft: '-=150'
            }, 300, 'swing');
        });

        $(catNext).click(function () {
            $(catList).animate({
                scrollLeft: '+=150'
            }, 300, 'swing');
        });

        $(catList).scroll(function() {
            if ($(this).scrollLeft() > 5) {
                $(catBlock).addClass('is-scrolled');
            } else if ($(catBlock).hasClass('is-scrolled')) {
                $(catBlock).removeClass('is-scrolled');
            }
            // checar se scrollou totalmente ate a direita
            var divWidth = $(this).outerWidth();
            var scrollwidth = $(this).get(0).scrollWidth;
            if($(this).scrollLeft() >= scrollwidth - divWidth - 5){
                $(catBlock).addClass('is-full-scrolled');
            } else if ($(catBlock).hasClass('is-full-scrolled')) {
                $(catBlock).removeClass('is-full-scrolled');
            }
        });
    }

    // Transform string into slug
    var isIE = window.navigator.msPointerEnabled;

    function slugify(content) {
        if (!isIE) {
            content = content.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        }

        content = content.replace(/&/g, '-e-');
        content = content.replace(/[^a-zA-Z0-9\s]/g,"");
        content = content.toLowerCase();
        content = content.replace(/\s/g,'-');
        return content;
    }

    // Table of contents
    var sideSticky = $('.side-sticky');
    sideSticky.css({'top': headerInnerHeight + 70 + 'px'});
    var tocBox = $('.toc-box');
    var tocList = $('.toc-list');
    var tableOfContents = '';
    var newLine, el, title, titleId, link, slug;

    $('#article-content h2').each(function() {
        el = $(this);
        title = el.text();
        titleId = el.attr('id');

        // if (titleId == undefined) {
            slug = slugify(title);
            el.attr('id', slug);
            titleId = el.attr('id');
        // }

        link = '#' + titleId;

        newLine =
        '<li class="toc-item">' +
        '<a href="' + link + '">' +
        title +
        '</a>' +
        '</li>';

        tableOfContents += newLine;
    });

    if (tableOfContents) {
        tocBox.show();
        $(tocList).prepend(tableOfContents);
        // Table of contents scroll listener
        window.addEventListener('scroll', debounce(function() {
            var scrollTop = $(document).scrollTop();
            var anchors = $('#article-content').find('h2');

            for (var i = 0; i < anchors.length; i++){
                if (scrollTop > $(anchors[i]).offset().top - (headerInnerHeight + 70)) {
                    $('.toc-list li a[href="#' + $(anchors[i]).attr('id') + '"]').addClass('is-scrolled');
                } else {
                    $('.toc-list li a[href="#' + $(anchors[i]).attr('id') + '"]').removeClass('is-scrolled');
                    $('.toc-list li a[href="#' + $(anchors[i]).attr('id') + '"]').removeClass('is-active');
                }
            }

            $('.toc-list li a.is-scrolled').removeClass('is-active');
            $('.hide-on-mobile li a.is-scrolled').last().addClass('is-active');
        }, 10));
    }

    // Resize listener
    window.addEventListener('resize', debounce(function(){
        var headerHeight = header.outerHeight();
        var headerInnerHeight = header.height();
        bodyOffset.css({'padding-top': headerHeight - 1 + 'px'});
        sideSticky.css({'top': headerInnerHeight + 70 + 'px'});

        if ($("body").has("#cat-blog").length) {
            if ($(catList).get(0).scrollWidth - $(catList).outerWidth() <= 0) {
                $(catBlock).addClass('no-scroll');
            } else {
                $(catBlock).removeClass('no-scroll');
            }
        }
    }, 100));

    // Anchor scroll
    $('a[href*="#"]:not([href="#"])').click(function (event) {
        event.preventDefault();
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var el = this;
            var hash = $($(this).attr('href'));
            var target = hash.length ? hash : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top-headerInnerHeight-50
                }, 1000);

                // Fechar menu mobile
                closeMenuMobile();

                // Mudar hash na URL
                history.pushState({}, '', el.href);
            }
        }
    });

    $('a[href="#"]').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
        // Fechar menu mobile
        closeMenuMobile();
    });

    var hash = location.hash;

    if ($("body").has(hash).length) {
        $('html, body').animate({
            scrollTop: $($(hash).offset().top-headerInnerHeight-50)
        }, 1000);
    }
});

// -------------------------------------
// #MAGNIFIC-POPUP
// -------------------------------------

$(document).ready(function () {
    $('.gallery-popup, .wp-block-gallery').each(function() { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            closeOnContentClick: true,
            closeBtnInside: false,
            fixedContentPos: true,
            tLoading: 'Carregando a imagem...',
            mainClass: 'mfp-no-margins mfp-fade',
            removalDelay: 300,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: 'A imagem não pode ser carregada.',
            },
        });
    });
});

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-flexbox-svg-setclasses !*/
!function(e,n,t){function r(e,n){return typeof e===n}function o(){var e,n,t,o,s,i,l;for(var a in w)if(w.hasOwnProperty(a)){if(e=[],n=w[a],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(o=r(n.fn,"function")?n.fn():n.fn,s=0;s<e.length;s++)i=e[s],l=i.split("."),1===l.length?Modernizr[l[0]]=o:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=o),C.push((o?"":"no-")+l.join("-"))}}function s(e){var n=x.className,t=Modernizr._config.classPrefix||"";if(_&&(n=n.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(r,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),_?x.className.baseVal=n:x.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):_?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function l(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function a(e,n){return!!~(""+e).indexOf(n)}function f(e,n){return function(){return e.apply(n,arguments)}}function u(e,n,t){var o;for(var s in e)if(e[s]in n)return t===!1?e[s]:(o=n[e[s]],r(o,"function")?f(o,t||n):o);return!1}function c(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function d(n,t,r){var o;if("getComputedStyle"in e){o=getComputedStyle.call(e,n,t);var s=e.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(s){var i=s.error?"error":"log";s[i].call(s,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!t&&n.currentStyle&&n.currentStyle[r];return o}function p(){var e=n.body;return e||(e=i(_?"svg":"body"),e.fake=!0),e}function m(e,t,r,o){var s,l,a,f,u="modernizr",c=i("div"),d=p();if(parseInt(r,10))for(;r--;)a=i("div"),a.id=o?o[r]:u+(r+1),c.appendChild(a);return s=i("style"),s.type="text/css",s.id="s"+u,(d.fake?d:c).appendChild(s),d.appendChild(c),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(n.createTextNode(e)),c.id=u,d.fake&&(d.style.background="",d.style.overflow="hidden",f=x.style.overflow,x.style.overflow="hidden",x.appendChild(d)),l=t(c,e),d.fake?(d.parentNode.removeChild(d),x.style.overflow=f,x.offsetHeight):c.parentNode.removeChild(c),!!l}function g(n,r){var o=n.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(c(n[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var s=[];o--;)s.push("("+c(n[o])+":"+r+")");return s=s.join(" or "),m("@supports ("+s+") { #modernizr { position: absolute; } }",function(e){return"absolute"==d(e,null,"position")})}return t}function v(e,n,o,s){function f(){c&&(delete z.style,delete z.modElem)}if(s=r(s,"undefined")?!1:s,!r(o,"undefined")){var u=g(e,o);if(!r(u,"undefined"))return u}for(var c,d,p,m,v,y=["modernizr","tspan","samp"];!z.style&&y.length;)c=!0,z.modElem=i(y.shift()),z.style=z.modElem.style;for(p=e.length,d=0;p>d;d++)if(m=e[d],v=z.style[m],a(m,"-")&&(m=l(m)),z.style[m]!==t){if(s||r(o,"undefined"))return f(),"pfx"==n?m:!0;try{z.style[m]=o}catch(h){}if(z.style[m]!=v)return f(),"pfx"==n?m:!0}return f(),!1}function y(e,n,t,o,s){var i=e.charAt(0).toUpperCase()+e.slice(1),l=(e+" "+E.join(i+" ")+i).split(" ");return r(n,"string")||r(n,"undefined")?v(l,n,o,s):(l=(e+" "+N.join(i+" ")+i).split(" "),u(l,n,t))}function h(e,n,r){return y(e,t,t,n,r)}var C=[],w=[],S={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){w.push({name:e,fn:n,options:t})},addAsyncTest:function(e){w.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=S,Modernizr=new Modernizr,Modernizr.addTest("svg",!!n.createElementNS&&!!n.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect);var x=n.documentElement,_="svg"===x.nodeName.toLowerCase(),b="Moz O ms Webkit",E=S._config.usePrefixes?b.split(" "):[];S._cssomPrefixes=E;var N=S._config.usePrefixes?b.toLowerCase().split(" "):[];S._domPrefixes=N;var P={elem:i("modernizr")};Modernizr._q.push(function(){delete P.elem});var z={style:P.elem.style};Modernizr._q.unshift(function(){delete z.style}),S.testAllProps=y,S.testAllProps=h,Modernizr.addTest("flexbox",h("flexBasis","1px",!0)),o(),s(C),delete S.addTest,delete S.addAsyncTest;for(var T=0;T<Modernizr._q.length;T++)Modernizr._q[T]();e.Modernizr=Modernizr}(window,document);

// -------------------------------------
// #SVG FALLBACK
// -------------------------------------

if (!Modernizr.svg) {
    $('img[src*="svg"]').attr('src', function () {
        return $(this).attr('src').replace('.svg', '.png');
    });
}
